import { lazy, Suspense, useEffect, useState } from 'react';

declare global {
    interface Window {
        toggleDevtools?: () => void;
    }
}

const DEVTOOLS_ENVS = ['local', 'sandbox'];

// The default export is compiled out of production builds, so sandbox needs the /production entry.
const ReactQueryDevtoolsProduction = lazy(() =>
    import('@tanstack/react-query-devtools/production').then((module) => ({
        default: module.ReactQueryDevtools,
    })),
);

type Props = {
    appEnv: string;
};

export function ReactQueryDevtoolsToggle({ appEnv }: Props) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!DEVTOOLS_ENVS.includes(appEnv)) {
            return;
        }

        window.toggleDevtools = () => setIsVisible((visible) => !visible);
        console.info('React Query devtools available — run window.toggleDevtools()');

        return () => {
            delete window.toggleDevtools;
        };
    }, [appEnv]);

    if (!isVisible) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <ReactQueryDevtoolsProduction />
        </Suspense>
    );
}
